<h5 mat-dialog-title>{{ data?.modalTitle }}</h5>
<div mat-dialog-content>
  <!--<mat-checkbox [(ngModel)]="editLabel" (change)='showLabel($event)'>
  Renommer ce type de frais pour cet AAP -
  <span style="color:#FF0000">ATTENTION ne pas changer la nature du frais</span>
</mat-checkbox>-->
@for (translation of translations; track translation; let i = $index) {
  <div
    class="form-group"
    >
    <hr>
      <p><strong>{{
        translation.locale === "fr" ? "Français" : "English"
      }}</strong></p>
      <label for="description-{{ i }}">Description</label>
      <textarea
        class="form-control"
        id="description-{{ i }}"
        name="description-{{ i }}"
        [(ngModel)]="translation.description"
        required
      ></textarea>
    </div>
  }
  <hr>
    <mat-checkbox [(ngModel)]="addMax" (change)='showMaxFields($event)'>
      Ajouter un montant maximal sur ce type de frais
    </mat-checkbox>
    @if (addMax) {
      <div class="row mt-1">
        <div class="col-6">
          <fieldset class="form-group">
            <label for="typeMontant">Mode de contrôle</label><br>
            <mat-select class="form-control" id="typeMontant" [(ngModel)]="typeMaximum">
              <mat-option [value]="null"></mat-option>
              <mat-option [value]="'pourcent'">Pourcentage</mat-option>
              <mat-option [value]="'montant'">Montant</mat-option>
            </mat-select>
          </fieldset>
        </div>
        <div class="col-6">
          <fieldset class="form-group">
            <label for="montant">Valeur</label>
            <input type="text" id="montant" class="form-control" [(ngModel)]="numberMaximum"
              onfocus="this.select()" [currencyMask]="typeMaximum === 'pourcent' ? INPUT_POURCENT_CONFIG : INPUT_CURRENCY_CONFIG" (ngModelChange)="adaptMontant($event)"
              >
            </fieldset>
          </div>
        </div>
      }
    </div>
    <div mat-dialog-actions>
      <button mat-button type="button" [mat-dialog-close]="false">
        {{ data?.cancel }}
      </button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="translationNotValide() && (!typeMaximum || !numberMaximum || numberMaximum === 0)"
        (click)="submit()"
        >
        {{ data?.confirm }}
      </button>
    </div>
